import { Oval } from "react-loader-spinner";

const colors = require("@theme/colors") as Record<string, any>;

export type SpinnerTemplateProps = { variant?: "small" | "large", size?: number; color?: string, secondaryColor?: string };

export const SpinnerTemplate = ({
  variant = "small",
  color,
  secondaryColor,
  // size = 20,
  // color = "#FFFFFF",
  // secondaryColor = "rgba(255,255,255,0.3)",
}: SpinnerTemplateProps): JSX.Element => {
  return (
    <Oval
      height={variant === "small" ? 18 : 38}
      width={variant === "small" ? 18 : 38}
      color={color ?? (variant === "small" ? "#FFFFFF" : colors.primary.medium)}
      secondaryColor={secondaryColor ?? (variant === "small" ? "rgba(255,255,255,0.3)" : colors.neutral.medium)}
      strokeWidth={4}
      strokeWidthSecondary={4}
      ariaLabel="loading"
    />
  );
};
